import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Box } from '@material-ui/core';

import { useGiftCardAvailableStyles } from './styles';
import { simpleUrl } from '../../../../config/paths';

const GiftCardAvailable = ({ ...props }) => {
  const { mobile, amountAvailable } = props;
  const classes = useGiftCardAvailableStyles({ mobile });
  return (
    <Box
      className={classes.container}
      width="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h3" className={classes.title}>
        Tu saldo disponible es:
      </Typography>
      <Typography className={classes.balance} data-cy="avalaibleAmountGiftCard">
        {' '}
        ${amountAvailable}{' '}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={() => window.open(simpleUrl, '_blank')}
        disabled={Number(amountAvailable) === 0}
      >
        Ir a comprar
      </Button>
    </Box>
  );
};

GiftCardAvailable.propTypes = {
  mobile: PropTypes.bool,
  amountAvailable: PropTypes.string,
};

export default GiftCardAvailable;
